import { beneficiaryRiskType } from 'sections/CustomerAccounts/BottomSection/tables.types';
import { permissionEnums } from './permission.constants';
import {
	addDays,
	endOfDay,
	startOfDay,
	startOfMonth,
	endOfMonth,
	addMonths,
	startOfWeek,
	endOfWeek,
	startOfYear,
	endOfYear,
	addYears,
	isValid,
	isToday,
	isYesterday,
	format,
} from 'date-fns';
import { useTheme } from '@mui/material';
import { generalStatusEnum } from './global.constants';

export enum pagesEnum {
	LOGIN = 'login',
	AUTHORIZATION = 'authorization',
	DASHBOARD = 'client-dashboard',
	MAIN_DASHBOARD = 'dashboard',
	CONTENT_PAGE = 'content',
	IN_PROGRESS_REQUESTS = 'in-progress-requests',
	REPORTS = 'reports',
	CLIENTS_DASHBOARD = 'clients-dashboard',
	CLIENTS_DASHBOARD_SIGNER = 'clients-dashboard-signer',
	CUSTOMER_ACCOUNTS = 'customer-accounts',
	NEW_ACCOUNT = 'new-account',
	ACCOUNTS = 'accounts',
	APPROVE = 'approve',
	CUSTOMER_ACCOUNTS_DETAILS = 'customer-accounts-details',
	NEW_CLIENT = 'new-client',
	PENDING_REQUESTS = 'pending-requests',
	HYPER_MONITORING = 'hyper-monitoring',
	DIGITAL_BALANCE_REQUESTS = 'digital-balance-requests',
	//MANAGE_PENDING_REQUESTS = 'manage-pending-request',
	COMPANY_FEATURE_CREATE = 'company/create',
	COMPANY_FEATURE_PROFILE = 'company/profile',
	COMPANY_FEATURE_APPROVE = 'company/approve',
	PLANS_BUSINESS_MODEL = 'plans-business-model',
	PAGE_NOT_FOUND = '404',
	COUNTRIES_MANAGEMENT = 'countries-management',
	PAYMENTS_PURPOSE_MANAGEMENT = 'payments_purpose_management',
	PAYMENT_CATEGORIES = 'payment-categories',
	MANAGE_CUSTOMER_RELATIONS = 'customer-relations-management',
	BENEFITS = 'benefits',
	SYSTEM_SETTINGS = 'system-settings',
	DIGITAL_DEPOSIT_BANK_AVAILABILITY = 'digital-deposit-bank-availability',
	WEBHOOK_MONITORING = 'webhook-monitoring',
	WEBHOOK_OPERATIONS_DASHBOARD = 'webhook-operations-dashboard',
	SYSTEM_MESSAGES = 'system-messages',
	SYSTEM_MESSAGES_CREATE = 'system-messages/create',
}

export type pageType = {
	name: pagesEnum;
	link: string;
	icon: any;
};

export enum categoriesEnum {
	OPEN_SYSTEM = 'open system ui',
	ERRORS = 'errors',
	WELCOME_SCREEN = 'welcome screen',
	PLANS = 'plans',
	TERMS_AND_USE = 'terms and use',
	ARTICLES = 'articles',
	NOTIFICATIONS = 'notifications',
	EMAIL = 'email',
}

export enum groupsEnum {
	OPEN_ALL = 'OPEN_ALL',
}

export enum featureTitleEnum {
	PLANS = 'תכניות עסקיות',
	PLANS_BUSINESS_MODEL = 'מודל עסקי',
}

export interface IMenuItemChild {
	category?: string;
	feature?: string;
	displayTitle: string;
	permissions: string[];
	link?: string;
	icon?: string;
	children?: IMenuItemChild[];
}

export interface IMenuItem {
	name: string;
	icon: string;
	permissions: string[];
	children?: IMenuItemChild[];
	link?: string;
}

export const sideBarSystemManagementItem = {
	name: 'system_management',
	icon: 'content-writing',
	permissions: [permissionEnums.MENU_SYSTEM_MANAGEMENT],
	children: [
		{
			category: categoriesEnum.OPEN_SYSTEM,
			displayTitle: 'דפי מערכת Open',
			permissions: [permissionEnums.OPEN_PAGES_CONTENT],
			icon: 'open-system',
		},
		{
			category: categoriesEnum.NOTIFICATIONS,
			feature: categoriesEnum.NOTIFICATIONS,
			displayTitle: 'התראות',
			permissions: [permissionEnums.NOTIFICATIONS_CONTENT],
			icon: 'bell',
		},
		{
			displayTitle: 'דואר אלקטרוני',
			category: categoriesEnum.EMAIL,
			feature: categoriesEnum.EMAIL,
			permissions: [permissionEnums.EMAIL_CONTENT],
			icon: 'mail',
		},
		{
			category: categoriesEnum.ERRORS,
			feature: categoriesEnum.ERRORS,
			displayTitle: 'שגיאות',
			permissions: [permissionEnums.ERRORS_CONTENT],
			icon: 'warning',
		},
		{
			displayTitle: 'מודל עסקי',
			permissions: [permissionEnums.BUSINESS_MODEL_CONTENT],
			icon: 'swap',
			link: '/' + pagesEnum.PLANS_BUSINESS_MODEL,
		},
		{
			displayTitle: 'הטבות ללקוח',
			permissions: [permissionEnums.VIEW_BENEFIT],
			icon: 'benefits',
			link: '/' + pagesEnum.BENEFITS,
		},
		{
			displayTitle: 'ניהול מדינות',
			permissions: [permissionEnums.EDIT_COUNTRIES], // TEMPORARY!!! I created a new group with permission edit_countries. db updated, but data not coming from server
			icon: 'browser',
			link: '/' + pagesEnum.COUNTRIES_MANAGEMENT,
		},
		{
			displayTitle: 'זמינות הפקדה דיגיטלית',
			permissions: [permissionEnums.EDIT_SYSTEM_SETTINGS],
			icon: 'browser',
			link: '/' + pagesEnum.DIGITAL_DEPOSIT_BANK_AVAILABILITY,
		},
		{
			displayTitle: 'ניהול סיבות תשלום',
			permissions: [permissionEnums.EDIT_PAYMENTS_PURPOSE], // TEMPORARY!!! I created a new group with permission edit_countries. db updated, but data not coming from server
			icon: 'browser',
			link: '/' + pagesEnum.PAYMENTS_PURPOSE_MANAGEMENT,
		},
		{
			displayTitle: 'ניהול קשרי לקוחות',
			permissions: [permissionEnums.EDIT_CUSTOMER_RELATIONS], // TEMPORARY!!! I created a new group with permission edit_countries. db updated, but data not coming from server
			icon: 'browser',
			link: '/' + pagesEnum.MANAGE_CUSTOMER_RELATIONS,
		},
		{
			displayTitle: 'קטגוריות תשלום',
			permissions: [permissionEnums.VIEW_PAYMENT_CATEGORIES],
			icon: 'browser',
			link: '/' + pagesEnum.PAYMENT_CATEGORIES,
		},
		{
			displayTitle: 'הגדרות מערכת',
			permissions: [permissionEnums.EDIT_SYSTEM_SETTINGS],
			icon: 'browser',
			link: '/' + pagesEnum.SYSTEM_SETTINGS,
		},
	],
};

export const sideBarItems: IMenuItem[] = [
	{
		name: 'dashboard',
		icon: 'menu-dashboard',
		permissions: [permissionEnums.MENU_DASHBOARD],
		link: '/' + pagesEnum.MAIN_DASHBOARD,
	},
	{
		name: 'incoming_client',
		icon: 'user-avatar',
		permissions: [permissionEnums.MENU_INCOMING_CLIENT],
		children: [
			{
				displayTitle: 'פתיחת חשבון חדש',
				link: '/' + pagesEnum.ACCOUNTS + '/' + pagesEnum.NEW_ACCOUNT + '/create',
				permissions: [permissionEnums.ADD_NEW_ACCOUNT],
				icon: 'new-client',
			},
			{
				displayTitle: 'חשבונות בתהליך',
				link: '/' + pagesEnum.ACCOUNTS,
				permissions: [permissionEnums.IN_PROGRESS_ACCOUNTS],
				icon: 'in-progress-client',
			},
		],
	},
	{
		name: 'clients_activity_management',
		icon: 'analytics',
		permissions: [permissionEnums.MENU_MANAGE_CLIENTS_ACTIVITY],
		children: [
			{
				displayTitle: 'דאשבורד',
				link: '/' + pagesEnum.DASHBOARD,
				permissions: [permissionEnums.CLIENTS_ACTIVITY_DASHBOARD],
				icon: 'dashboard',
			},
			{
				displayTitle: 'דאשבורד מורשה חתימה',
				link: '/' + pagesEnum.DASHBOARD + '/' + pagesEnum.CLIENTS_DASHBOARD_SIGNER,
				permissions: [permissionEnums.CLIENTS_ACTIVITY_DASHBOARD_SIGNER],
				icon: 'dashboard-signer',
			},
			{
				displayTitle: 'חשבונות לקוח',
				link: '/' + pagesEnum.CUSTOMER_ACCOUNTS,
				permissions: [permissionEnums.CUSTOMER_ACCOUNTS],
				icon: 'client-accounts',
			},
			{
				displayTitle: 'בקשות ממתינות',
				link: '/' + pagesEnum.PENDING_REQUESTS,
				permissions: [permissionEnums.CLIENTS_ACTIVITY_PENDING_REQUESTS],
				icon: 'pending-request',
			},
			{
				displayTitle: 'תור שליחת נתונים להייפר',
				link: '/' + pagesEnum.HYPER_MONITORING,
				permissions: [permissionEnums.VIEW_HYPER_MONITORING],
				icon: 'dashboard',
			},
			{
				displayTitle: 'דו"חות',
				feature: 'ייצוא דו"חות',
				link: '/' + pagesEnum.REPORTS,
				permissions: [permissionEnums.CLIENTS_ACTIVITY_REPORTS],
				icon: 'report',
			},
		],
	},
	{
		name: 'webhook_monitoring',
		icon: 'analytics',
		permissions: [permissionEnums.MENU_WEBHOOK_MONITORING],
		children: [
			{
				displayTitle: 'דשבורד Webhook',
				link: '/' + pagesEnum.WEBHOOK_MONITORING + '/' + pagesEnum.WEBHOOK_OPERATIONS_DASHBOARD,
				permissions: [permissionEnums.VIEW_WEBHOOK_MONITORING],
				icon: 'dashboard',
			},
		],
	},
	sideBarSystemManagementItem,
	{
		name: 'marketing_management',
		icon: 'marketing',
		permissions: [permissionEnums.MENU_MARKETING_MANAGEMENT, permissionEnums.MENU_SYSTEM_MESSAGES],
		children: [
			{
				link: '/system-messages',
				displayTitle: 'הודעות מערכת',
				permissions: [permissionEnums.VIEW_SYSTEM_MESSAGES],
				icon: 'bell',
			},
			{
				category: categoriesEnum.ARTICLES,
				feature: categoriesEnum.ARTICLES,
				displayTitle: 'מאמרים במסך הבית',
				permissions: [permissionEnums.HOME_ARTICLES_CONTENT],
				icon: 'articles',
			},
			{
				category: categoriesEnum.WELCOME_SCREEN,
				feature: categoriesEnum.WELCOME_SCREEN,
				displayTitle: 'מסך Welcome',
				permissions: [permissionEnums.WELCOME_SCREEN_CONTENT],
				icon: 'welcome',
			},
			{
				category: categoriesEnum.PLANS,
				feature: categoriesEnum.PLANS,
				displayTitle: featureTitleEnum.PLANS,
				permissions: [permissionEnums.MARKETING_EDITOR],
				icon: 'briefcase',
			},
			{
				category: categoriesEnum.TERMS_AND_USE,
				feature: categoriesEnum.TERMS_AND_USE,
				displayTitle: 'תנאי שימוש',
				permissions: [permissionEnums.TERMS_AMD_CONDITIONS_CONTENT],
				icon: 'clock',
			},
		],
	},
];

export const errorMessages = {
	generalError: 'An error occurred',
};

export enum timing {
	TODAY = 'today',
	YESTERDAY = 'yesterday',
	DATE = 'dd.MM.yyyy',
	DATE_FOR_SERVICE = 'yyyy-MM-dd',
	FULLDATE = 'dd.MM.yyyy HH:mm',
	FULLDATE_WITH_SECONDS = 'dd.MM.yyyy HH:mm:ss',
	TIME = 'HH:mm',
	MONTH_DAY = 'MMM dd, yyyy',
}
export const getDay = (dateText?: string): string => {
	if (dateText && isValid(new Date(dateText))) {
		if (isToday(new Date(dateText))) {
			return timing.TODAY;
		}
		if (isYesterday(new Date(dateText))) {
			return timing.YESTERDAY;
		} else {
			return format(new Date(dateText), timing.DATE);
		}
	}
	return String(dateText);
};

export const defineds = {
	startOfWeek: startOfWeek(new Date()),
	endOfWeek: endOfWeek(new Date()),
	startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
	endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
	startOfToday: startOfDay(new Date()),
	startOfLastSevenDay: startOfDay(addDays(new Date(), -7)),
	startOfLastThirtyDay: startOfDay(addDays(new Date(), -30)),
	startOfLastNinetyDay: startOfDay(addDays(new Date(), -90)),
	startOfLast365Day: startOfDay(addDays(new Date(), -365)),
	endOfToday: endOfDay(new Date()),
	startOfYesterday: startOfDay(addDays(new Date(), -1)),
	endOfYesterday: endOfDay(addDays(new Date(), -1)),
	startOfMonth: startOfMonth(new Date()),
	endOfMonth: endOfMonth(new Date()),
	startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
	endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
	startOflastYear: startOfYear(addYears(new Date(), -1)),
	endOflastYear: endOfYear(addYears(new Date(), -1)),
};

export const getIndicationColor = (risk: string) => {
	const theme = useTheme();
	switch (risk) {
		case beneficiaryRiskType.LOW:
		case generalStatusEnum.APPROVED:
			return theme.palette.root.inputFocusGreen;
		case beneficiaryRiskType.MEDIUM:
			return theme.palette.root.formTitle;
		case beneficiaryRiskType.HIGH:
			return theme.palette.root.orange_3;
		case beneficiaryRiskType.VERY_HIGH:
		case generalStatusEnum.DECLINED:
			return theme.palette.root.error;
		case generalStatusEnum.AWAITING:
		case generalStatusEnum.PENDING:
			return theme.palette.root.yellow;
		case generalStatusEnum.CANCELED:
			return theme.palette.root.purple;
		default:
			break;
	}
};

export type userMessage = {
	exist: boolean;
	text?: string;
	subText?: string | object;
	icon?: any;
};
export const initialMessage: userMessage = {
	exist: false,
};

export type emailFields = {
	email: string;
	content: string;
	header: string;
	link: string;
};

export const emailFieldsInitial = { email: '', content: '', header: '', link: '' };
